import template from './MultiSel.html';

export default {
	template,
	data() {
		return {
			itemsShown: false,
			itemsChbLastIndex: null,
			isItemsCheckedAll: false,
			inverted: false,
			movingFastStep: 10,
			checkedKeysMap: {},
			stickyCheckedKeysMap: {},
			searchVal: '',
			tfText: '',

			visibleLimit: 0,
			visibleLimitPortion: 100
		};
	},
	props: [
		'value',
		'items',
		'icon',
		'with-not',
		'presets',
		'no-sort',
		'debug',
		'default-show',
		'no-clear',
		'disabled',
		'placeholder',
		'open'
	],
	computed: {
		itemsWithSort() {
			let items = [...this.items].map((item, i) => {
				if (item.sortVal == null) {
					item.sortVal = i;
				}
				return item;
			});
			return items;
		},
		filteredItems() {
			if (!this.items) return this.items;
			let items = this.itemsWithSort.filter(this.checkItemMatch);

			items = items.sort((a, b) => {
				let aChecked = this.stickyCheckedKeysMap[a.key];
				let bChecked = this.stickyCheckedKeysMap[b.key];

				if (!aChecked && bChecked) return 1;
				if (aChecked && !bChecked) return -1;

				if (a.sortVal > b.sortVal) return 1;
				if (a.sortVal < b.sortVal) return -1;

				return 0;
			});

			return items;
		},
		checkedItemsCnt() {
			return Object.keys(this.checkedKeysMap).length;
		}
	},
	methods: {
		showItems() {
			this.visibleLimit = this.visibleLimitPortion;

			let winWidth = window.innerWidth;

			this.itemsShown = true;
			this.searchVal = '';
			this.itemsChbLastIndex = null;

			this.stickyCheckedKeysMap = {...this.checkedKeysMap};

			this.$nextTick(() => {
				let boxRight = this.$refs.itemsBox.getBoundingClientRect().right;
				let overlay = Math.round(boxRight - winWidth + 10);

				if (overlay > 0) {
					//TODO: fix overflow
				}

				this.tryFocusSearch();
				this.$refs.scrollableBox.scrollTop = 0;
			});
		},
		hideItems() {
			if (this.open) return;
			this.itemsShown = false;
			this.updateVal();
		},
		tryFocusSearch() {
			if (this.$refs.searchTf && this.app.win.width >= this.app.win.lg) {
				this.$refs.searchTf.focus();
			}
		},
		focus() {
			this.showItems();
		},
		updateTfText() {
			let texts = Object.keys(this.checkedKeysMap).map(key => {
				let item = this.checkedKeysMap[key];
				return item.displayVal || item.val;
			});
			this.tfText = (this.inverted ? this.ii('NOT') + ': ' : '') + texts.join(', ');
		},
		checkItemMatch(item) {
			if (!this.searchVal) return true;

			if (!item) return false;

			let regex = new RegExp(this.util.escapeRegex(this.searchVal).replace(/[, ]+/g, '|'), 'i');
			if (regex.test(item.sVal || item.val)) return true;
		},
		setInverted(isInv) {
			this.inverted = isInv;
			this.tryFocusSearch();
		},
		check(e, item, index) {
			let checked = e.target.checked;

			if (e.shiftKey && this.itemsChbLastIndex != null) {
				let start = Math.min(index, this.itemsChbLastIndex);
				let end = Math.max(index, this.itemsChbLastIndex) + 1;

				this.filteredItems.slice(start, end).forEach(item => {
					if (e.target.checked) {
						this.$set(this.checkedKeysMap, item.key, item);
					} else {
						this.$delete(this.checkedKeysMap, item.key);
					}
				});
			} else if (checked) {
				this.$set(this.checkedKeysMap, item.key, item);
			} else {
				this.$delete(this.checkedKeysMap, item.key);
			}

			this.itemsChbLastIndex = index;
			this.tryFocusSearch();
		},
		updateModel() {
			this.updateTfText();

			let keys = Object.keys(this.checkedKeysMap);
			let val;
			if (keys.length) {
				val = (this.inverted ? 'n_' : '') + keys.join(',');
			} else {
				val = '';
			}

			this.$emit('input', val);
			this.$emit('change', {isTrusted: true});
		},
		updateVal() {
			if (!this.value || !this.items) {
				this.inverted = false;
				this.checkedKeysMap = {};
				return;
			}
			let map = {};
			let val = this.value;
			if (val.indexOf('n_') === 0) {
				val = val.slice(2);
				this.inverted = true;
			} else {
				this.inverted = false;
			}
			val.split(',').forEach(key => {
				let item = this.items.filter(el => el.key == key)[0];
				if (!item) return;

				map[key] = item;
			});
			this.checkedKeysMap = map;
		},
		choosePreset(e, preset) {
			let keys = preset.key;
			if (e.ctrlKey) {
				let checkedKeys = Object.keys(this.checkedKeysMap).join(',');
				keys = (checkedKeys ? checkedKeys + ',' : '') + keys;
				keys = keys.split(',').filter((v, i, a) => a.indexOf(v) === i).join(',');
			}

			let map = {};
			keys.split(',').forEach(key => {
				let item = this.items.find(it => it.key == key);
				if (item) {
					map[key] = item;
				}
			});
			this.checkedKeysMap = map;
			let filtredKeys = Object.keys(map).join(',');

			this.$emit('input', filtredKeys);
			this.$emit('change', {isTrusted: true});

			this.updateTfText();
			this.hideItems();
		},
		clear() {
			this.$emit('input', '');
			this.$emit('change', {isTrusted: true});

			this.hideItems();
			this.tfText = '';
		},
		checkAll() {
			let uncheckedExist = this.filteredItems.filter(item => !this.checkedKeysMap[item.key]).length;

			this.filteredItems.forEach(item => {
				if (uncheckedExist) {
					this.$set(this.checkedKeysMap, item.key, item);
				} else {
					this.$delete(this.checkedKeysMap, item.key);
				}
			});

			this.itemsChbLastIndex = null;
			this.tryFocusSearch();
		},
		onEnterAction() {
			if (this.util.isObjectEmpty(this.checkedKeysMap) && !this.util.isObjectEmpty(this.filteredItems) && this.searchVal) {
				this.$set(this.checkedKeysMap, this.filteredItems[0].key, this.filteredItems[0]);
			}

			this.apply();
		},
		apply() {
			this.updateModel();
			this.hideItems();
		},
		initScroll() {
			this.$refs.scrollableBox.addEventListener('scroll', e => {
				const offset = 50;

				let scrolled = e.target.scrollTop + e.target.offsetHeight;
				let total = e.target.scrollHeight;

				if (scrolled >= total - offset) {
					this.visibleLimit += this.visibleLimitPortion;
				}
			})
		}
	},
	watch: {
		value() {
			this.updateVal();
			this.updateTfText();
		},
		items() {
			this.updateVal();
			this.updateTfText();
		},
		searchVal() {
			this.$refs.scrollableBox.scrollTo(0, 0);
			this.visibleLimit = this.visibleLimitPortion;
			this.itemsChbLastIndex = null;
		}
	},
	mounted() {
		this.itemsShown = this.defaultShow;
		this.updateVal();
		this.updateTfText();

		if (this.open) {
			this.showItems();
		}

		this.initScroll();
	}
};